import { useQuery } from "@tanstack/react-query"
import api from "api"
import { queries } from "api/queries"
import { useState } from "react"

import { timeIntervalOptions } from "./types"

/** Shared by the Qualification/Course Overview pages' Progress + Time Spent
 * + Overall GPA card. */
export const useOverviewAnalytics = ({
  itemId,
  itemType,
}: {
  itemId: number
  itemType: string
}) => {
  const [selectedTimeInterval, setSelectedTimeInterval] = useState(
    timeIntervalOptions[0]
  )

  const { data: analyticsData, isError: isAnalyticsError } = useQuery({
    enabled: Boolean(itemId),
    queryKey: queries.analytics.getLearnerAnalytics(itemId, itemType).queryKey,
    queryFn: () =>
      api.analytics.getLearnerAnalytics({
        urlParams: {
          learningItemId: itemId,
          learningItemType: itemType,
        },
        params: {},
      }),
  })

  const timeSpentQuery = useQuery({
    enabled: Boolean(itemId),
    queryKey: queries.analytics.getTimeSpentAnalyticsQueryKey({
      itemId,
      itemType,
      interval: selectedTimeInterval.value,
    }).queryKey,
    queryFn: () =>
      api.analytics.getTimeSpentAnalytics({
        urlParams: {
          itemId,
          itemType,
        },
        params: { interval: selectedTimeInterval.value },
      }),
  })

  const sortedTerms = Array.isArray(analyticsData?.terms)
    ? [...analyticsData.terms].sort((a, b) => Number(a.name) - Number(b.name))
    : []

  return {
    analyticsData,
    isAnalyticsError,
    timeSpentQuery,
    selectedTimeInterval,
    setSelectedTimeInterval,
    sortedTerms,
  }
}
